import { ECountry, ELanguage } from '@portals/help-center-core';
import { resolveUrl } from '@portal-root/geo-utils';
import { getAnalyticsExternalData } from '@/_utils';

// Имена UTM-параметров заданы стандартом
/* eslint-disable camelcase */
export const UTM_PARAMS = {
  utm_source: 'prowb',
  utm_medium: 'webinar',
  utm_campaign: 'wbpro',
  utm_content: 'helpcenter',
};
/* eslint-enable camelcase */
const UTM_PARAMS_STRING = new URLSearchParams(UTM_PARAMS).toString();

type TProps = {
  country: ECountry;
  locale: string;
  href: string;
  landingUrl: string;
};

export const getPortalLandingUrl = ({
  country,
  locale,
  href,
  landingUrl,
}: TProps): string => {
  const { idSupplier } = getAnalyticsExternalData();

  if (idSupplier) {
    return href;
  }

  const resolvedLandingUrl = resolveUrl(landingUrl);

  if (country === ECountry.CHINA) {
    // для китая лендинг не принимает страну - только язык
    return `${resolvedLandingUrl}/${ELanguage.CHINESE_CORRECT}?${UTM_PARAMS_STRING}`;
  }

  return `${resolvedLandingUrl}/${country}/${locale}?${UTM_PARAMS_STRING}`;
};
